<svg xmlns="http://www.w3.org/2000/svg"
     version="1.1"
     id="radial-progress"
     [attr.viewBox]="'0 0 ' + radius*2 + ' ' + radius*2"
     [attr.height]="radius * 2"
     [attr.width]="radius * 2">
  <defs>
    <filter id="dropshadow"
            height="130%">
      <feGaussianBlur in="SourceAlpha"
                      stdDeviation="2" /> <!-- stdDeviation is how much to blur -->
      <feOffset dx="-4"
                dy="0"
                result="offsetblur" /> <!-- how much to offset -->
      <feComponentTransfer>
        <feFuncA type="linear"
                 slope="0.1" /> <!-- slope is the opacity of the shadow -->
      </feComponentTransfer>
      <feMerge>
        <feMergeNode /> <!-- this contains the offset blurred image -->
        <feMergeNode in="SourceGraphic" /> <!-- this contains the element that the filter is applied to -->
      </feMerge>
    </filter>

    <filter id="f1"
            x="0"
            y="0"
            width="200%"
            height="200%">
      <feOffset result="offOut"
                in="SourceGraphic"
                dx="20"
                dy="20" />
      <feBlend in="SourceGraphic"
               in2="offOut"
               mode="normal" />
    </filter>
  </defs>

  <circle name="bg"
          stroke="transparent"
          fill="white"
          [attr.r]="normalizedRadius"
          [attr.cx]="radius"
          [attr.cy]="radius"
          filter="url(#dropshadow)" />
  <circle name="currentStep"
          class="current-circle-step"
          fill="white"
          [attr.stroke-dasharray]="circumference + ' ' + circumference"
          [attr.stroke-dashoffset]="strokeDashoffset"
          [attr.stroke-width]="strokeWidth"
          [attr.r]="normalizedRadius"
          [attr.cx]="radius"
          [attr.cy]="radius"
          stroke-linecap="round" />
  <circle name="completedSteps"
          class="completed-circle-steps"
          fill="transparent"
          [attr.stroke-dasharray]="circumference + ' ' + circumference"
          [attr.stroke-dashoffset]="completedStepsStrokeDashoffset"
          [attr.stroke-width]="strokeWidth"
          [attr.r]="normalizedRadius"
          [attr.cx]="radius"
          [attr.cy]="radius"
          stroke-linecap="round" />
  <text x="50%"
        y="50%"
        dominant-baseline="middle"
        text-anchor="middle"
        class="fw-bold">
    {{'BOOKING-PART.STEPPER.RADIAL-PROGRESS.DONE-OF-TOTAL' | translate: { 'doneAmount': currentStepIndex, 'totalAmount':
    stepsCount} }}
  </text>
</svg>
